import React from 'react';
import './Brokerage.css';

// Eingebettetes Limit-Order-Formular (Order pruefen -> ggf. eigene TAN ->
// platziert). Wird sowohl vom Orderbuch ("Neue Order") als auch von den
// Ordervorlagen ("platzieren") verwendet - initialOrder liefert die
// Vorbelegung, in beiden Faellen ist ein aktiver comdirect-Login (siehe
// BrokerageLoginForm) bereits Voraussetzung, bevor dieses Formular angezeigt
// wird.
export default function BrokerageOrderForm(props) {

	const x = props.x;
	const task = (name, data, cb) => x.was.axPost('Backend/webapp.php?module=Banking&task=' + name, data, cb);

	const [order, setOrder] = React.useState(props.initialOrder);
	const [challenge, setChallenge] = React.useState(null);
	const [tanCode, setTanCode] = React.useState('');
	const [costInfo, setCostInfo] = React.useState(null);
	const [busy, setBusy] = React.useState(false);
	const [error, setError] = React.useState('');

	function orderValid() {
		return order.depotId !== '' && order.instrumentId !== '' && order.venueId !== ''
			&& order.quantity !== '' && order.limitPrice !== '';
	}

	function submitPreview() {
		setBusy(true);
		setError('');
		task('BrokerageOrderPreview', { connectionId: props.connectionId, ...order }, (result) => {
			setBusy(false);
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				setError(content.message || 'Order-Prüfung fehlgeschlagen.');
				return;
			}
			setCostInfo(content.costInfo || null);
			if (content.status === 'tan-required') {
				setChallenge({ type: content.challengeType, text: content.challengeText });
				setTanCode('');
				return;
			}
			x.wah.addHint('Order ' + content.orderId + ' platziert.');
			props.onDone(content.orderId);
		});
	}

	function submitTan() {
		setBusy(true);
		setError('');
		task('BrokerageOrderConfirm', { connectionId: props.connectionId, tanCode }, (result) => {
			setBusy(false);
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				setError(content.message || 'Order-Bestätigung fehlgeschlagen.');
				return;
			}
			x.wah.addHint('Order ' + content.orderId + ' platziert.');
			props.onDone(content.orderId);
		});
	}

	if (challenge !== null) {
		const needsCode = challenge.type === 'M_TAN';
		return (
			<div className="brokerage-card">
				{challenge.type === 'P_TAN_PUSH' &&
					<p className="brokerage-hint"><i className="bi bi-phone"></i> Bitte in der comdirect-App bestätigen.</p>
				}
				{challenge.text && <p className="brokerage-hint">{challenge.text}</p>}
				{costInfo && <p className="brokerage-hint">Kosteninfo: {JSON.stringify(costInfo)}</p>}
				{needsCode &&
					<React.Fragment>
						<label htmlFor="brokerage-order-tan">TAN</label>
						<input
							id="brokerage-order-tan"
							type="text"
							autoComplete="off"
							value={tanCode}
							onChange={(e) => setTanCode(e.target.value)}
							onKeyDown={(e) => { if (e.key === 'Enter') submitTan(); }}
							autoFocus
						/>
					</React.Fragment>
				}
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
				<button type="button" className="btn" disabled={busy || (needsCode && tanCode === '')} onClick={submitTan}>
					{busy ? 'Bestätige…' : 'Order bestätigen'}
				</button>
			</div>
		);
	}

	return (
		<div className="brokerage-card">
			<label>Wertpapierkennung (ISIN/instrumentId)</label>
			<input value={order.instrumentId} onChange={(e) => setOrder({ ...order, instrumentId: e.target.value })} />
			<label>Handelsplatz (venueId)</label>
			<input value={order.venueId} onChange={(e) => setOrder({ ...order, venueId: e.target.value })} />
			<label>Seite</label>
			<select value={order.side} onChange={(e) => setOrder({ ...order, side: e.target.value })}>
				<option value="BUY">Kauf</option>
				<option value="SELL">Verkauf</option>
			</select>
			<label>Stückzahl</label>
			<input type="number" min="1" value={order.quantity} onChange={(e) => setOrder({ ...order, quantity: e.target.value })} />
			<label>Limit (EUR)</label>
			<input type="number" min="0" step="0.01" value={order.limitPrice} onChange={(e) => setOrder({ ...order, limitPrice: e.target.value })} />
			{costInfo && <p className="brokerage-hint">Kosteninfo: {JSON.stringify(costInfo)}</p>}
			{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
			<div className="brokerage-actions">
				{props.onCancel && <button type="button" className="btn btn-secondary" onClick={props.onCancel}>Abbrechen</button>}
				<button type="button" className="btn" disabled={busy || !orderValid()} onClick={submitPreview}>
					{busy ? 'Prüfe…' : 'Order prüfen'}
				</button>
			</div>
		</div>
	)

};
